import React from "react";

import { Action, Category } from "@/constants/events";
import { BrandFeaturedProducts } from "@/custom-types/BrandDetail";
import { useEventTracker } from "@/hooks/useEventTracker";

import Carousel from "@/components/botanic/Carousel";
import ProductCard, {
  ProductCardProduct,
} from "@/components/ProductCard/ProductCard";
import TrackImpression from "@/components/TrackImpression";

const ProductSpotlight = ({
  brandId,
  brandName,
  brandSlug,
  featuredProducts,
}: {
  brandId: number;
  brandName: string;
  brandSlug: string;
  featuredProducts: BrandFeaturedProducts[];
}) => {
  const { publishEvent } = useEventTracker();

  const getCbdContentLabel = (cbdValue: number) => {
    return cbdValue > 0 ? `CBD ${cbdValue}%` : "";
  };

  const getThcContentLabel = (thcValue: number) => {
    return thcValue > 0 ? `THC ${thcValue}%` : "";
  };

  return (
    <TrackImpression
      trackingFunction={() => {
        publishEvent({
          action: Action.impression,
          brandId: brandId,
          category: Category.brandPaid,
          label: "products spotlight",
        });
      }}
    >
      <Carousel
        cardsPerSlide={3}
        title={
          <h2>
            <span className="heading--m text-md font-extrabold">
              Product spotlight
            </span>
          </h2>
        }
        subtitle={
          <span>Here are the top recommended products from {brandName}</span>
        }
        seeMoreHref={`/brands/${brandSlug}/catalog`}
        seeMoreText="see the full catalog"
        seeMoreOnClick={() => {
          publishEvent({
            action: Action.click,
            brandId: brandId,
            category: Category.brandPaid,
            label: "products spotlight link",
          });
        }}
      >
        {featuredProducts.map((product) => {
          const productCard = {
            avgApprovedPublicReviewRating:
              product.avgApprovedPublicReviewRating,
            brandName: brandName,
            brandSlug: brandSlug,
            categoryName: null,
            cbdContentLabel: getCbdContentLabel(
              Number(product?.strain?.cbd ?? 0),
            ),
            countApprovedPublicReviews: product.countApprovedPublicReviews,
            discountLabel: null,
            displayPrice: null,
            id: product.id,
            imageUrl: product.imageUrl,
            isBestSeller: false,
            isStaffPick: false,
            name: product.name,
            normalizedQuantityLabel: null,
            offerLabel: null,
            price: null,
            quantity: null,
            regularPrice: null,
            slug: product.slug,
            subcategoryName: product.subcategoryName,
            thcContentLabel: getThcContentLabel(
              Number(product?.strain?.thc ?? 0),
            ),
            unit: null,
          } as ProductCardProduct;

          return (
            <ProductCard
              product={productCard}
              key={product.id}
              onClick={() => {
                publishEvent({
                  action: Action.click,
                  brandId: brandId,
                  category: Category.brandPaid,
                  label: "products spotlight card",
                  productId: product.id,
                });
              }}
              className="h-full"
            />
          );
        })}
      </Carousel>
    </TrackImpression>
  );
};

export default ProductSpotlight;
